<template>
    <div ref="$mobileMenuWrapper" class="main-menu-wrapper-mobile">
        <div class="menu-inner" data-lenis-prevent-touch>
            <ul class="main-menu-mobile">
                <UiMenuItemMobile
                    v-for="item_level_1 in headerMenu"
                    :key="item_level_1.id"
                    :item="item_level_1"
                    :li-class="!!item_level_1?.children?.length ? 'w-children' : ''"
                    @on-menu-item-click="onMenuItemClick"
                >
                    <template v-if="!!item_level_1?.children?.length" #childrens>
                        <ul ref="$childrens" class="main-menu-mobile-childrens">
                            <UiMenuItemMobile
                                v-for="item_level_2 in item_level_1.children"
                                :key="item_level_2.id"
                                :item="item_level_2"
                                :li-class="!!item_level_2.children?.length ? 'w-children' : ''"
                                @on-menu-item-click="onMenuItemClick"
                            >
                                <template v-if="!!item_level_2.children?.length" #childrens>
                                    <ul ref="$childrens" class="main-menu-mobile-childrens">
                                        <UiMenuItemMobile
                                            v-for="item_level_3 in item_level_2.children"
                                            :key="item_level_3.id"
                                            :item="item_level_3"
                                            :li-class="!!item_level_3?.children.length ? 'w-children' : ''"
                                            @on-menu-item-click="onMenuItemClick"
                                        />
                                    </ul>
                                </template>
                            </UiMenuItemMobile>
                        </ul>
                    </template>
                </UiMenuItemMobile>
            </ul>
        </div>
        <div v-if="!!settings[0]?.headerLinks?.length" class="menu-buttons">
            <UiLink :link="settings[0]?.headerLinks[0]" :style="'transparent w-border'" />
        </div>
    </div>
</template>

<script setup lang="ts">
import type { CmsItem } from '~/types/cms';

const { $gsap: gsap } = useNuxtApp();
const settingsData = useSettingsData();
const settings = computed<CmsItem[]>(() => settingsData.value.filter(item => item.siteId == useSiteId()));
const menuData = useMenusData();
const headerMenu = computed<CmsItem[]>(() => menuData.value.menu_header.filter(item => item.siteId == useSiteId()));
const $childrens = ref<HTMLElement[]>([]);
const $mobileMenuWrapper = ref<HTMLDivElement | null>(null);

const mobileMenu = useToggleMobileMenu();
const lenis = useLenisData();

const onMenuItemClick = (e: MouseEvent) => {
    const target = e.currentTarget as HTMLElement;

    const isActive = target.classList.contains('active');
    const nextEl = target.nextElementSibling as HTMLElement;

    gsap.to(nextEl, {
        height: isActive ? 0 : 'auto',
        paddingBlock: isActive ? 0 : 15,
        duration: 0.3,
        ease: 'none',
        onComplete: () => {
            target.classList.toggle('active');
        }
    });
};

onMounted(() => {
    if (!$mobileMenuWrapper.value) return;

    gsap.set($mobileMenuWrapper.value!, {
        opacity: 0,
        pointerEvents: 'none',
        yPercent: 20
    });

    $childrens.value.forEach(menu => {
        gsap.set(menu, {
            height: 0,
            paddingBlock: 0,
            overflow: 'hidden'
        });
    });
});

watch(
    () => mobileMenu.value,
    state => {
        gsap.to($mobileMenuWrapper.value!, {
            opacity: state ? 1 : 0,
            pointerEvents: state ? 'all' : 'none',
            yPercent: state ? 0 : 20,
            ease: 'sine',
            duration: 0.3,
            onStart: () => {
                if (state) {
                    lenis.value?.stop();
                } else {
                    lenis.value?.start();
                }
            },
            onComplete: () => {
                if (state == false) {
                    const allBtns = $mobileMenuWrapper.value?.querySelectorAll('.menu-button.active') ?? [];
                    if (allBtns.length) allBtns.forEach(item => item.classList.remove('active'));

                    $childrens.value.forEach(menu => {
                        gsap.set(menu, {
                            height: 0,
                            paddingBlock: 0,
                            overflow: 'hidden'
                        });
                    });
                }
            }
        });
    }
);
</script>
